import React from 'react';
import PropTypes from 'prop-types';
import DashboardLayout from '../DashboardLayout';
import { useLocation } from 'react-router-dom';

/**
 * AppLayout - Wrapper around DashboardLayout that adds breadcrumb support
 * Used for pages that need breadcrumb navigation
 */
const AppLayout = ({ 
  breadcrumbTitle,
  role,
  userType,
  layoutType = 'topnav',
  activeMenu,
  showBreadcrumbs = true,
  children 
}) => {
  const location = useLocation();
  
  return (
    <DashboardLayout
      role={role}
      userType={userType}
      layoutType={layoutType}
      activeMenu={activeMenu}
      showBreadcrumbs={showBreadcrumbs}
    >
      {showBreadcrumbs && breadcrumbTitle && (
        <div className="breadcrumb-bar breadcrumb-bar-info">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-12">
                <div className="breadcrumb-list">
                  <h2 className="breadcrumb-title">{breadcrumbTitle}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {children}
    </DashboardLayout>
  );
};

AppLayout.propTypes = {
  breadcrumbTitle: PropTypes.string,
  role: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  userType: PropTypes.string,
  layoutType: PropTypes.string,
  activeMenu: PropTypes.string,
  showBreadcrumbs: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default AppLayout;

